import React, { Component } from 'react'
import { Button, Form, Input, Select, Modal } from 'antd'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { message } from 'antd'
import InputMask from 'react-input-mask';
import { all, get, create } from '../../services/restApi'
import PropTypes from 'prop-types'
import config from '../../utils/config'
const _ = require('underscore')
const mexico_states = require('../../data/mexico_states')
const usa_states = require('../../data/usa_states')

const FormItem = Form.Item;
const Option = Select.Option;
const confirm = Modal.confirm

class ClientNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            client: {},
            hotels: [],
            states_options: []
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.params.clientId) {
            this.props.dispatch({type: 'app/showLoading'})

            get('Client', this.props.params.clientId).then((resp) => {

                if (resp.hotel)
                    resp.hotel = {key: resp.hotel.objectId, label: resp.hotel.name};

                this.props.form.setFieldsValue(resp);
                this.setState({ client: resp });

                this.props.dispatch({type: 'app/hideLoading'})
            })
        }

        // Query
        let query = {};
        /*if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId*/

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 50}).then((resp) => {
            this.setState({
                hotels: resp.results
            });

            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});
        })
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Validator: Checa el correcto formato del teléfono
    */
    checkPhone (rule, value, callback) {
        if (value && value.replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa el correcto formato del celular
    */
    checkEmail (rule, value, callback) {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; 
        if (value && value.length > 0 && !re.test(value[value.length - 1])) {
            callback('Por favor, ingrese un correo electrónico válido!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el cliente!');
        } else {
            callback();
        }
    }


    /**
    * Muestra los estados según el país elegido
    */
    handleCountry (value) {
        this.props.form.setFieldsValue({state: ''});

        if (value === 'México')
            this.setState({states_options: mexico_states.map(d => <Option key={d.name} label={d.name}>{d.name}</Option>)})
                              
        if (value === 'USA')
            this.setState({states_options: usa_states.map(d => <Option key={d.name} label={d.name}>{d.name}</Option>)})
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            values.phone1 = values.phone1.replace(/[^\d.]/g, '');
            if (values.phone2) values.phone2 = values.phone2.replace(/[^\d.]/g, '');
            if (values.mobile_phone) values.mobile_phone = values.mobile_phone.replace(/[^\d.]/g, '');
            
            if (!this.props.params.clientId) {
                // CREA

                // Model
                let data = {...values}
                data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
                data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};

                this.props.dispatch({type: 'app/showButtonLoading'})
                
                create('Client', data).then((resp) => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    // Reseteamos los campos
                    this.props.form.resetFields();
                    this.props.form.setFieldsValue({phone1: '', phone2: '', mobile_phone: ''})
                    this.setState({imageUrl: ''})

                    let context = this.context
                    const clientCreated = resp.objectId

                    confirm({
                        title: '¿Desea generar la factura del cliente? Precione "OK" para SI o cancelar para solo guardar el cliente',
                        onOk () {
                            context.router.push(`/invoices/new-invoice/${clientCreated}`);
                        }
                    })  
                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                _.extend(this.state.client, {
                    ...values, 
                    hotel: {...values.hotel, name: values.hotel.label} 
                });
                this.props.dispatch({type: 'client/update', payload: this.state.client})
                this.context.router.goBack()
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link to="/clients"><i className="fa fa-arrow-circle-left"></i></Link>
                        Cliente
                    </h1>
                </section>

                <section className="content">
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Hotel
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <FormItem label="Hotel al que pertenece" hasFeedback>
                                            {this.props.form.getFieldDecorator('hotel', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el hotel al que pertence el cliente',
                                                }, {
                                                    validator: this.checkHotel.bind(this)
                                                }]
                                            })(
                                                <Select 
                                                    size='large'
                                                    mode="combobox"
                                                    onChange={this.handleSelectHotelChange.bind(this)}
                                                    filterOption={false}
                                                    labelInValue={true}
                                                    optionLabelProp='label'
                                                    disabled={this.state.currentHotel ? true : false}
                                                    >
                                                    {hotel_options}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos Fiscales
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <FormItem label="Nombre completo, denominación o razón social" hasFeedback>
                                            {this.props.form.getFieldDecorator('name', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el nombre del cliente'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Tipo de persona" hasFeedback>
                                            {this.props.form.getFieldDecorator('type', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el tipo de persona'
                                                }]
                                            })(
                                                <Select size='large'>
                                                    <Option value="fisica">Física</Option>
                                                    <Option value="moral">Moral</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="RFC" hasFeedback>
                                            {this.props.form.getFieldDecorator('rfc', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el RFC del cliente',
                                                    max: 13,
                                                }]
                                            })(<Input size='large' style={{textTransform: 'uppercase'}} />)}
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Domicilio
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-2">
                                        <FormItem label="Calle" hasFeedback>
                                            {this.props.form.getFieldDecorator('street', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese la calle de la dirección'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Número Exterior" hasFeedback>
                                            {this.props.form.getFieldDecorator('exterior_number', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el número de la dirección'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Colonia" hasFeedback>
                                            {this.props.form.getFieldDecorator('colony')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Número Interior" hasFeedback>
                                            {this.props.form.getFieldDecorator('interior_number')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Localidad" hasFeedback>
                                            {this.props.form.getFieldDecorator('locality', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese la localidad'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Referencia" hasFeedback>
                                            {this.props.form.getFieldDecorator('reference')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Municipio" hasFeedback>
                                            {this.props.form.getFieldDecorator('city')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="País" hasFeedback>
                                            {this.props.form.getFieldDecorator('country', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el país'
                                                }]
                                            })(
                                                <Select 
                                                    showSearch 
                                                    size="large" 
                                                    onChange={this.handleCountry.bind(this)}
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                                                    <Option value="México">México</Option>
                                                    <Option value="USA">Estados Unidos</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Estado" hasFeedback>
                                            {this.props.form.getFieldDecorator('state', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el estado'
                                                }]
                                            })(
                                                <Select 
                                                    showSearch 
                                                    size="large"
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                                                    {this.state.states_options}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="CP" hasFeedback>
                                            {this.props.form.getFieldDecorator('zip', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el código postal de la dirección'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos de Contacto
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <FormItem label="Nombre de contacto" hasFeedback>
                                            {this.props.form.getFieldDecorator('contact_name', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el nombre del contacto'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Teléfono 1" hasFeedback>
                                            {this.props.form.getFieldDecorator('phone1', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el teléfono de contacto'
                                                }, {
                                                    validator: this.checkPhone.bind(this)
                                                }]
                                            })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Teléfono 2" hasFeedback>
                                            {this.props.form.getFieldDecorator('phone2', {
                                                rules: [{}, {
                                                    validator: this.checkPhone.bind(this)
                                                }]
                                            })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Celular" hasFeedback>
                                            {this.props.form.getFieldDecorator('mobile_phone', {
                                                rules: [{}, {
                                                    validator: this.checkPhone.bind(this)
                                                }]
                                            })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Fax" hasFeedback>
                                            {this.props.form.getFieldDecorator('fax')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Emails" hasFeedback extra="Enter para agregar uno o más correos">
                                            {this.props.form.getFieldDecorator('emails', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese al menos un correo electrónico'
                                                }, {
                                                    validator: this.checkEmail.bind(this)
                                                }]
                                            })(
                                                <Select mode="tags" size="large" />
                                            )}
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            <div className="row text-center paddingBottom30">
                                <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                    Guardar
                                </Button>
                            </div>
                        </div>

                    </Form>
                </section>
            </div>
        )
    }
}

ClientNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({client, app}) => ({client, app}))(Form.create()(ClientNew))


// WEBPACK FOOTER //
// ./src/components/clients/clientNew.js